import { resolveAgentCompanyLogoUrl } from "./resolveAgentCompanyLogoUrl";

/**
 * לוגו + פרטי סוכנות מההזמנה (אותו מקור אמת כמו OrderSummary / PackageOrderSummary).
 * @param {object|null|undefined} order
 * @returns {{ logoUrl: string|null, companyName: string|null, contactName: string|null, phone: string|null, email: string|null }|null}
 */
export function buildCustomerQuoteAgencyBranding(order) {
  const agent = order?.agent;
  if (!agent || typeof agent !== "object") return null;
  const logoUrl = resolveAgentCompanyLogoUrl(agent);
  const companyName =
    (agent.companyname || agent.companyName || "").trim() || null;
  const first = (agent.firstname || agent.firstName || "").trim();
  const last = (agent.lastname || agent.lastName || "").trim();
  const contactName = [first, last].filter(Boolean).join(" ").trim() || null;
  const phone = (agent.cell || agent.phone || agent.Phone || "").trim() || null;
  const email = (agent.email || agent.Email || "").trim() || null;
  if (!logoUrl && !companyName && !contactName && !phone && !email) return null;
  return { logoUrl, companyName, contactName, phone, email };
}
